import * as Yup from "yup";
import * as errorMessages from "../../../utils/form-errors";

export const marketingOnlyToLeadForm = {
  division_id: undefined,
  communities: []
};

export const marketingOnlyToLeadSchema = Yup.object().shape({
  division_id: Yup.string()
    .required(errorMessages.REQUIRE_FIELD)
    .nullable(),
  communities: Yup.array()
    .default("Select...")
    .nullable()
});

export const marketingOnlyToProspectForm = {
  input: [
    {
      community_id: undefined,
      csm_id: undefined
    }
  ]
};

export const marketingOnlyToProspectSchema = Yup.object().shape({
  input: Yup.array().of(
    Yup.object().shape({
      community_id: Yup.string()
        .required(errorMessages.REQUIRE_FIELD)
        .nullable(),
      csm_id: Yup.string()
        .default("Select...")
        .nullable()
    })
  )
});